import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackModalOpen } from './tracking';
import { getOfferChatSrc } from './utils';
import { closeChat } from '../../../actions/chat';
import { ChatPopup } from '../../../components/ChatPopup';
import { selectDate } from '../../../selectors/results/selectDate';
import { selectChat } from '../../../selectors/selectChat';
import { selectSource } from 'shared/selectors';
import { selectMlSearchSessionGuid } from 'shared/selectors/mlSearchSessionGuid';
import { selectJsonQuery, selectTotalOffers } from 'shared/selectors/results';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const OfferChatPopupContainer: React.FC = () => {
  const dispatch = useDispatch();
  const context = useApplicationContext();

  const { isOpened, offer, position, isEarlyAccess, placeType } = useSelector(selectChat);
  const jsonQuery = useSelector(selectJsonQuery);
  const totalOffers = useSelector(selectTotalOffers);
  const dates = useSelector(selectDate);
  const source = useSelector(selectSource);
  const mlSearchSessionGuid = useSelector(selectMlSearchSessionGuid);

  React.useEffect(() => {
    if (isOpened && offer && position) {
      trackModalOpen(offer, position, placeType, isEarlyAccess, source);
    }
  }, [isOpened, offer, position, placeType, isEarlyAccess, source]);

  const onClose = React.useCallback(() => dispatch(closeChat()), [dispatch]);

  if (!isOpened) {
    return null;
  }

  /**
   * @todo: удалить в задаче CD-260866
   */
  const isCpcAuctionEnabled = !!context.config.get<boolean>('auction.cpcEnabled');

  const src = getOfferChatSrc({
    offer,
    dates,
    jsonQuery,
    totalOffers,
    position,
    isEarlyAccess,
    mlSearchSessionGuid,
    isCpcAuctionEnabled,
  });

  return <ChatPopup src={src} onClose={onClose} />;
};
